module.exports = __webpack_public_path__ + "media/images/tmp/ig1-9619b445414a79b7ec8f6c266e25203a.png";